export const server = "https://giftofgodwholesale.com";

// export const server = "http://localhost:5000";
